import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/straithub/project/result.png'
import _imports_1 from '@/assets/straithub/project/delivery.png'
import _imports_2 from '@/assets/straithub/project/field.png'


const _withScopeId = n => (_pushScopeId("data-v-454e269a"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["id"]
const _hoisted_2 = { class: "project-section__wrap" }
const _hoisted_3 = { class: "project-section__media project-section__motion" }
const _hoisted_4 = { class: "project-section__details-wrap project-section__motion" }
const _hoisted_5 = { class: "project-section__details" }
const _hoisted_6 = ["aria-label"]
const _hoisted_7 = { class: "project-section__description" }
const _hoisted_8 = { class: "project-section__metrics" }
const _hoisted_9 = { class: "project-metric project-metric--result" }
const _hoisted_10 = { class: "project-metric__label" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_12 = { class: "project-metric__value" }
const _hoisted_13 = { class: "project-metric__caption" }
const _hoisted_14 = { class: "project-metric project-metric--delivery" }
const _hoisted_15 = { class: "project-metric__label" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: ""
}, null, -1))
const _hoisted_17 = { class: "project-metric__status" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: ""
}, null, -1))

import { computed, onMounted, onUnmounted, ref } from "vue";
import { useI18n } from "vue-i18n";
import ProjectCarousel from "./ProjectCarousel.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'ProjectSection',
  props: {
    project: {}
  },
  setup(__props: any) {



const { locale } = useI18n();
const sectionRef = ref<HTMLElement | null>(null);
const isVisible = ref(false);
let observer: IntersectionObserver | null = null;

const resultLabel = computed(() =>
  locale.value === "zh" ? "项目成果" : "Result"
);
const deliveryLabel = computed(() =>
  locale.value === "zh" ? "项目交付" : "Delivery"
);
const categoryLabel = computed(() =>
  locale.value === "zh" ? "项目分类" : "Project categories"
);

onMounted(() => {
  if (
    typeof IntersectionObserver === "undefined" ||
    window.matchMedia("(prefers-reduced-motion: reduce)").matches
  ) {
    isVisible.value = true;
    return;
  }

  observer = new IntersectionObserver(
    (entries) => {
      if (entries[0]?.isIntersecting) {
        isVisible.value = true;
        observer?.disconnect();
      }
    },
    { threshold: 0.18 }
  );

  if (sectionRef.value) observer.observe(sectionRef.value);
});

onUnmounted(() => observer?.disconnect());

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", {
    id: _ctx.project.id,
    ref_key: "sectionRef",
    ref: sectionRef,
    class: _normalizeClass(["project-section", [
      _ctx.project.reverse ? 'project-section--reverse' : 'project-section--normal',
      { 'is-visible': isVisible.value },
    ]])
  }, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(ProjectCarousel, {
          slides: _ctx.project.slides,
          "alt-prefix": _ctx.project.title
        }, null, 8, ["slides", "alt-prefix"])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("article", _hoisted_5, [
          _createElementVNode("div", null, [
            _createElementVNode("div", {
              class: "project-section__tags",
              "aria-label": categoryLabel.value
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.project.tags, (tag, index) => {
                return (_openBlock(), _createElementBlock("span", {
                  key: tag,
                  class: _normalizeClass(["project-section__tag", 
                  index === 0
                    ? 'project-section__tag--green'
                    : 'project-section__tag--blue'
                ])
                }, _toDisplayString(tag), 3))
              }), 128))
            ], 8, _hoisted_6),
            _createElementVNode("h2", null, _toDisplayString(_ctx.project.title), 1),
            _createElementVNode("div", _hoisted_7, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.project.paragraphs, (paragraph) => {
                return (_openBlock(), _createElementBlock("p", { key: paragraph }, _toDisplayString(paragraph), 1))
              }), 128))
            ])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _hoisted_11,
                _createElementVNode("span", null, _toDisplayString(resultLabel.value), 1)
              ]),
              _createElementVNode("strong", _hoisted_12, _toDisplayString(_ctx.project.result.value), 1),
              _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.project.result.caption), 1)
            ]),
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("div", _hoisted_15, [
                _hoisted_16,
                _createElementVNode("span", null, _toDisplayString(deliveryLabel.value), 1)
              ]),
              _createElementVNode("div", _hoisted_17, [
                _hoisted_18,
                _createElementVNode("strong", null, _toDisplayString(_ctx.project.delivery.title), 1)
              ]),
              _createElementVNode("p", null, _toDisplayString(_ctx.project.delivery.description), 1)
            ])
          ])
        ])
      ])
    ])
  ], 10, _hoisted_1))
}
}

})